export const EXTERNAL_TRANSFER_CHANNELS: ReadonlyArray<string> = Object.freeze([
  'PESONET', 'INSTAPAY', 'DIRECT'
]);
